import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row", "expander"];

  expand() {
    this.rowTargets.forEach((row) => (row.hidden = false));
    this.expanderTargets.forEach((expander) => (expander.hidden = true));
  }
}
